import React from "react";
import Footer from "./components/footer/footer";
import Header from "./components/header/header";
import Home from "./pages/home/home";
import About from "./pages/about/about";
import Contact from "./pages/contacct/contact";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Product from "./pages/product/product";
import Cart from "./pages/cart/cart";
import Catalog from "./pages/catalog/catalog";
import Invoice from "./pages/invoice/invoice";
import NotFound from "./pages/notFound/nout_found";
const App = () => {
  return (
    <Router>
      <Header />
      <Switch>
        <Route path="/" exact component={Home} />
        <Route path="/about" component={About} />
        <Route path="/contact" component={Contact} />
        <Route path="/catalog" component={Catalog} />
        <Route path="/product/:id" component={Product} />
        <Route path="/cart/:id?" component={Cart} />
        <Route path="/invoice" component={Invoice} />
        <Route component={NotFound} />
      </Switch>
      <Footer />
    </Router>
  );
};
export default App;
// tst comit
